/**
 * compressImage - Comprime imagem no cliente antes do upload
 * Reduz tamanho e qualidade para acelerar envio e economizar banda
 * @param {File} file - Arquivo de imagem original
 * @param {object} options - maxWidth, maxHeight, quality
 * @returns {Promise<File>} - Arquivo comprimido
 */
export async function compressImage(file, options = {}) {
    const { maxWidth = 1200, maxHeight = 1200, quality = 0.7 } = options;

    // Skip if already small (< 500KB) or not an image
    if (file.size < 500 * 1024 || !file.type.startsWith('image/')) {
        return file;
    }

    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let { width, height } = img;

                // Scale down proportionally
                if (width > maxWidth || height > maxHeight) {
                    const ratio = Math.min(maxWidth / width, maxHeight / height);
                    width = Math.round(width * ratio);
                    height = Math.round(height * ratio);
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (!blob || blob.size >= file.size) {
                            // Compression didn't help, return original
                            resolve(file);
                            return;
                        }
                        const compressed = new File([blob], file.name, {
                            type: 'image/jpeg',
                            lastModified: Date.now(),
                        });
                        resolve(compressed);
                    },
                    'image/jpeg',
                    quality
                );
            };
            img.onerror = () => resolve(file); // Fallback to original on error
            img.src = e.target.result;
        };
        reader.onerror = () => resolve(file); // Fallback to original on error
        reader.readAsDataURL(file);
    });
}
